<template>
    <div class="jnCustomerReceiveDetail">
        <van-nav-bar
            title="合同详情"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="tit">
            <h4>客户名称:{{ client_name }}</h4>
        </div>
        <div class="btns">
            <template v-for="(item, index) in timeType">
                <button
                    :class="{'active': selectType == index}"
                    @click="switchingTimeType(index)"
                    :key="index"
                >
                    {{ item.name }}
                </button>
            </template>
        </div>
        <div class="time-select-con" v-if="selectType == 2">
            <div class="time-select">
                <span class="iconfont iconshijian"></span>
                <span class="time" @click="handleShowCalendar(1)">{{ startTime }}</span>
                <span class="split-line"></span>
                <span class="iconfont iconshijian"></span>
                <span class="time" @click="handleShowCalendar(2)">{{ endTime }}</span>
            </div>
        </div>
        <div class="list-con">
            <ul v-for="(item, index) in list" :key="index">
                <li>
                    <h4>
                        <span class="iconfont icondanjubianhao"></span>
                        <span>合同编号：{{ item.contract_number }}</span>
                    </h4>
                    <div class="static-block">
                        <div class="static-item">
                            <div class="num">
                                {{ item.concrete_total_volume }}
                            </div>
                            <div class="lable">
                                累计方量(方)
                            </div>
                        </div>
                        <div class="static-item">
                            <div class="num">
                                {{ item.loans_receivable }}
                            </div>
                            <div class="lable">
                                累计应收(元)
                            </div>
                        </div>
                        <div class="static-item">
                            <div class="num">
                                {{ item.official_receipt }}
                                <div class="lable">
                                    累计实收(元)
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="static-middle">
                        <div class="static-item">
                            <div class="num">
                                {{ item.ending_balance_receivable }}
                            </div>
                            <div class="lable">
                                当前应收余额(元)
                            </div>
                        </div>
                        <div class="static-item">
                            <div class="num">
                                {{ item.balance_receivable_rate }}
                            </div>
                            <div class="lable">
                                合同回款率
                            </div>
                        </div>
                    </div>
                    <div class="customer-con">
                        <div class="customer-item">
                            <img src="./../../../assets/images/icons/icon_gy_3.png">
                            <span class="project-name">工程名称:{{ item.engineering_name }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="选择时间"
                :min-date="minDate"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchValue: '',
            startTime: '',
            endTime: '',
            choseTimeType: 0,
            showCalendarPop: false,
            currentDate: '',
            list: [],
            contract_number: '',
            client_name: '',
            // 时间控件最小时间
            minDate: new Date(2000, 0, 1),
            isLoading: false,
            // 时间类型
            timeType: [{
                name: '当前',
                val: 0,
            }, {
                name: '本年',
                val: 1,
            }, {
                name: '时间段',
                val: 2,
            }],
            // 选中时间类型
            selectType: null,
        };
    },
    watch: {
        selectType(newVal) {
            if (newVal === 0) {
                this.startTime = '2000-01-01 00:00:00';
                const newToday = this.formatDate();
                this.endTime = newToday + ' 23:59:59';

                this.handleReceivableClient();
            } else if (newVal === 1) {
                const nweYear = new Date().getFullYear();
                this.startTime = nweYear + '-01-01 00:00:00';
                const newToday = this.formatDate();
                this.endTime = newToday + ' 23:59:59';

                this.handleReceivableClient();
            }
        },
    },
    mounted() {
        this.contract_number = this.$route.params.contract_number;
        this.selectType = this.$route.params.selectType;
        this.startTime = this.$route.params.startTime;
        this.endTime = this.$route.params.endTime;
        this.client_name = this.$route.params.client_name;

        if (this.$route.params.selectType === 2) {
            this.handleReceivableClient();
        }
    },
    methods: {
        // 处理客户获取应收统计
        async handleReceivableClient() {
            const res = await this.receivableClient();
            if (res) {
                this.list = res;
            }
        },
        // 通过客户获取应收统计
        receivableClient() {
            const path = '/interfaceApi/sale/accounts/receivable_client_contract?clientName='
            + this.client_name + '&beginTime=' + this.startTime + '&endTime=' + this.endTime
            + '&contract_numbers=' + this.contract_number;
            return this.$axios.$get(path, { defEx: true });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 展示日历
        handleShowCalendar(type) {
            if (type === 1) {
                this.currentDate = new Date(this.startTime);
            } else {
                this.currentDate = new Date(this.endTime);
            }
            this.choseTimeType = type;
            this.showCalendarPop = true;
        },
        // 确认时间选择
        confirmDate(value) {
            this.showCalendarPop = false;
            if (this.choseTimeType === 1) {
                const newDate = this.formatDate(value);
                this.startTime = newDate + ' 00:00:00';
            } else {
                const newDate = this.formatDate(value);
                this.endTime = newDate + ' 23:59:59';
            }
            this.handleReceivableClient();
        },
        // 取消时间选择
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 切换时间段类型
        switchingTimeType(index) {
            this.selectType = index;
        },
        // 时间格式化
        formatDate(date) {
            if (date) {
                date = new Date(date);
            } else {
                date = new Date();
            }
            const Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            M = M < 10 ? '0' + M : M;
            D = D < 10 ? '0' + D : D;
            return Y + '-' + M + '-' + D;
        },
    },
};
</script>

<style lang="stylus">
.jnCustomerReceiveDetail
    height 100%
    .tit
        height 45rpx
        background #F3F9FF
        line-height 45rpx
        text-align center
        font-size 16rpx
        color #429CFB
    .btns
        display flex
        margin 15rpx
        button
            width 90rpx
            height 30rpx
            color #666666
            margin 0 15rpx
            font-size 14rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            background #fff
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
            &.active
                color #fff
                border-color #0E84FF
                background #3495FB
                box-shadow 2px 2px 8px #5494F3
    .time-select-con
        padding 0 15rpx 12rpx 15rpx
    .time-select
        box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
        border-radius 4rpx
        border 1px solid #D7D7D7
        height 36rpx
        line-height 36rpx
        display flex
        .split-line
            width 4px
            background-color #979EA7
            height 1px
            display inline-block
            margin 18rpx 0 0 5rpx
        .time
            font-size 13rpx
        .iconshijian
            color #979EA7
            margin 0 6rpx
    .list-con
        padding 0 15rpx 0 15rpx
        height calc(100% - 150rpx)
        overflow-y auto
        &.sectionHeight
            height calc(100% - 200rpx)
        li
            background #FFFFFF
            box-shadow: 1px 1px 4rpx 0 rgba(84, 148, 243, 0.5)
            border-radius 4rpx
            border 1px solid #D7D7D7
            margin-bottom 15rpx
            h4
                height 40rpx
                background rgba(85, 136, 241, 0.06)
                border-radius 4rpx 4rpx 0 0
                line-height 40rpx
                font-size 14rpx
                padding-left 15rpx
                display flex
                align-items center
                .icondanjubianhao
                    font-size 18rpx
                    color #3495FB
                    margin-right 5rpx
                span
                    font-size 16rpx
                    color #061F3E
            .static-block
                display flex
                border-bottom 1px solid #f0f0f0
                padding 10rpx
                .static-item
                    flex 1
                    .num
                        font-size 16rpx
                        color #666666
                    .lable
                        font-size 12rpx
                        color #979EA7
                    &:nth-child(1)
                        background #F5F5F5
                        padding 5rpx 10rpx
                        margin-right 10rpx
                    &:nth-child(2)
                        padding-top 5rpx
                    &:nth-child(3)
                        padding-top 5rpx
            .static-middle
                padding 10rpx 15rpx
                border-bottom 1px solid #f0f0f0
                display flex
                .static-item
                    padding 5rpx 15rpx
                    flex 1
                    text-align center
                    .num
                        font-size 16rpx
                    .lable
                        font-size 12rpx
                        color #666
                    &:nth-child(1)
                        background: rgba(250, 132, 54, 0.06)
                        margin-right 30rpx
                        .num
                            color #FF6600
                    &:nth-child(2)
                        background rgba(52, 149, 251, 0.06)
                        .num
                            color #3495FB
    .customer-con
        padding 15rpx 15rpx 0 15rpx
        .customer-item
            display flex
            align-items flex-start
            margin-bottom 10rpx
            img
                width 16rpx
                height 16rpx
                margin-right 5rpx
            .contract-link
                font-size 14rpx
                color #419DFF
                text-decoration underline
            .project-name
                font-size 14rpx
                color #666
</style>